module.exports = __webpack_public_path__ + "img/ic_404.1209b39c.png";